import { render, staticRenderFns } from "./manageExamQuestionsCopyQuestion.vue?vue&type=template&id=4115b7fe"
import script from "./manageExamQuestionsCopyQuestion.vue?vue&type=script&lang=js"
export * from "./manageExamQuestionsCopyQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports